import React, { useEffect } from "react";
import { addDays, format, compareAsc, isSameDay } from 'date-fns';
import {
  Typography, Grid, Paper
} from "@material-ui/core";
import * as wijmo from "@grapecity/wijmo";
import QARegistFormCR from '../component/portal/qaregist/customer/QARegistForm'
import QARegistFormEE from '../component/portal/qaregist/employee/QARegistForm'
import { getUserInfoList, typeUserInfoList, postQaContent, getCustomerList, typeCustomerList } from '../api/helpline/qa'
import { getCisUserList, getContractItemList, typeCisUserList, typeContractItemList } from '../api/helpline/keiyaku'
import { getCategory, typeCategory, getMemberList, typeMemberList } from '../api/helpline/master'
import { getUserInfo, typeUserInfo } from '../api/helpline/user'
import { useGlobalState } from '../provider/Provider'
import { cisUser } from "../User";

const rolecustomer = process.env.REACT_APP_ROLE_CUSTOMER!
const keiyakuss = process.env.REACT_APP_KEIYAKU_APP_SS!
const keiyakuss400 = process.env.REACT_APP_KEIYAKU_APP_SS400!

interface Form {
  qaStartSt: string,
  qaKindClsCd: string,
  qaWayClsCd: string,
  qaTitle: string,
  qPersonCd: string,
  qaSeCd: string,
  qaContents: string,
  qaStatusClsCd: string,
  answerDate: Date | null,
  relatedQaNo: string,
  keiyakuNo: string,
  custmNo: string,
  attachedFile: string,
  attachedFileData: string,
  createCd: string,
  custmDepNo: string,
  ssVersionClsCd: string,
  serverOsClsCd: string,
  serverDbClsCd: string,
  serverConnectClsCd: string,
  serverAsClsCd: string,
  clientOsClsCd: string,
  clientDbClsCd: string
}

interface Prop {
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleError: (err: any) => void,
  handleClickHome: () => void,
}

const QARegist: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const { handleNotificationOpen, handleError, handleClickHome } = props
  ////APIレスポンスState
  //ログインユーザー情報
  const [userInfo, setUserInfo] = React.useState<typeUserInfo>()
  //ユーザー情報(member)
  const [userInfoList, setUserInfoList] = React.useState<typeUserInfoList>()
  //顧客情報
  const [customerList, setCustomerList] = React.useState<typeCustomerList[]>([])
  //CIS社員情報
  const [cisUserList, setCisUserList] = React.useState<typeCisUserList[]>([])
  //契約項目
  const [contractItemList, setContractItemList] = React.useState<typeContractItemList[]>([])
  //メンバー情報一覧
  const [memberList, setMemberList] = React.useState<typeMemberList[]>([])
  ////カテゴリー取得
  //問合わせ方法
  const [questionway, setQuestionway] = React.useState<typeCategory[]>([])
  //QA対応状況
  const [qastatus, setQastatus] = React.useState<typeCategory[]>([])
  //SuperStreamバージョン
  const [ss_version, setSs_version] = React.useState<typeCategory[]>([])
  //サーバー環境（OS）
  const [ss_serverOS, setSs_serverOS] = React.useState<typeCategory[]>([])
  //サーバー環境（DB）
  const [ss_serverDB, setSs_serverDB] = React.useState<typeCategory[]>([])
  //サーバー環境（接続）
  const [ss_serverConnect, setSs_serverConnect] = React.useState<typeCategory[]>([])
  //アプリケーションサーバー
  const [ss_applicationserver, setSs_applicationserver] = React.useState<typeCategory[]>([])
  //クライアント環境（OS）
  const [ss_clientOS, setSs_clientOS] = React.useState<typeCategory[]>([])
  //クライアント環境（DB）
  const [ss_clientDB, setSs_clientDB] = React.useState<typeCategory[]>([])

  const initDate = new Date(addDays(Date.now(), 1))
  const todayDate: Date = new Date(Date.now())
  const [answerDate, setAnswerDate] = React.useState<Date | null>(null)
  const [selectKeiyaku, setSelectKeiyaku] = React.useState<typeContractItemList | undefined>()
  const [reqItem, setReqItem] = React.useState({
    qPersonCd: true,
    qaTitle: true,
    qaSeCd: true,
    custmNo: true,
    keiyakuNo: true,
  })
  const [loginUser, setLoginUser] = React.useState(false)
  const dateFormat = (datevalue: Date): string => {
    return format(datevalue, "yyyy/MM/dd")
  }
  const [loading, setLoading] = React.useState<boolean>(false)
  const [form, setForm] = React.useState<Form>({
    qaStartSt: dateFormat(todayDate),//* 今日日付 yyyy/mm/dd 変更不可
    qaKindClsCd: '0',//*
    qaWayClsCd: role === rolecustomer ? '0' : '1',//*
    qaTitle: '',//*
    qPersonCd: '',//*
    qaContents: '',//* 初期内容エリア拡大5 line
    qaSeCd: '',
    answerDate: null,
    qaStatusClsCd: role === rolecustomer ? '0' : 'd',//*
    relatedQaNo: '',
    keiyakuNo: '',//*
    custmNo: '',//*　変更不可
    attachedFile: '',
    attachedFileData: '',
    createCd: userId,//* 変更不可
    custmDepNo: '',//*
    ssVersionClsCd: '',
    serverOsClsCd: '',
    serverDbClsCd: '',
    serverConnectClsCd: '',
    serverAsClsCd: '',
    clientOsClsCd: '',
    clientDbClsCd: '',
  })
  //categorySort(降順)
  const sortDesc = (list: typeCategory[]) => {
    list.sort((a, b) => {
      if (a.categoryCd < b.categoryCd) {
        return 1;
      } else {
        return -1;
      }
    })
    return list
  }

  //文字数カット
  const MAX_LENGTH_Title = 200
  const formatString = (str: string, name: string) => {
    if (name === 'qaTitle') {
      if (str.length > MAX_LENGTH_Title) {
        return str.substr(0, MAX_LENGTH_Title)
      } else {
        return str
      }
    } else {
      return str
    }
  }

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    setForm({
      ...form,
      [event.target.name as string]: formatString(event.target.value as string, event.target.name as string)
    })
  }

  const handleClickMenu = (event: any) => {
    const val = contractItemList.filter(value => value.keiyakuNo === event.target.id)
    if (val && val.length === 1) {
      setSelectKeiyaku(val[0])
    }
  }

  const handleChangeFile = async (files: File[]) => {
    if (files[0]) {
      //base64Encode
      const base64Encode = (...parts: any) => {
        return new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = () => {
            if (typeof reader.result === 'string') {
              const offset = reader!.result!.indexOf(",") + 1;
              resolve(reader!.result!.slice(offset));
            }
          };
          reader.readAsDataURL(new Blob(parts));
        });
      }
      let file = files[0]
      const encodedFile = await base64Encode(file)
      setForm({
        ...form,
        "attachedFile": file.name,
        "attachedFileData": encodedFile as string
      })
    }
  }

  const handleRemoveFile = () => {
    setForm({
      ...form,
      "attachedFile": '',
      "attachedFileData": ''
    })
    return ''//表示msgなし
  }

  const _onInitialized = (sender: any) => {
    sender.calendar.formatItem.addHandler((sender: any, e: any) => {
      let weekday = e.data.getDay();
      wijmo.toggleClass(e.item, "date-sunday", weekday === 0);
      wijmo.toggleClass(e.item, "date-saturday", weekday === 6);
    })
  }
  const _validator = (date: number | Date) => {
    return isSameDay(date, initDate) || compareAsc(date, initDate) === 1
  }
  const _onValueChanged = (sender: { value: Date }) => {
    setAnswerDate(sender.value)
  }

  const handleChangeUserCd = (memberObj: typeMemberList) => {
    setForm({
      ...form,
      "qPersonCd": memberObj.userCd,
      "custmDepNo": memberObj.departmentCd
    })
  };

  const handleChangeCompanyCd = (companyObj: any) => {
    setForm({
      ...form,
      "custmNo": companyObj.companyCd,
      "custmDepNo": companyObj.departmentCd
    })
  }

  const handleChangeSeCd = (seObj: any) => {
    setForm({
      ...form,
      "qaSeCd": seObj.userCd
    })
  }

  const handleSetLoginUserCd = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoginUser(event.target.checked)
  }

  const onSubmit = () => {
    setLoading(true)
    if (answerDate) {
      form["answerDate"] = answerDate
    }
    if (loginUser) {
      getUserInfo(userId, userId, token, role).then(res => {
        form["qaSeCd"] = res.userCd as string
        postQaContent(userId, token, role, form).then(res => {
          setLoading(false)
          handleNotificationOpen('success', 'QAの新規登録')
          handleClickHome()
        }).catch(err => { setLoading(false); handleError(err) })
      }).catch(err => handleError(err))
    } else {
      postQaContent(userId, token, role, form).then(res => {
        setLoading(false)
        handleNotificationOpen('success', 'QAの新規登録')
        handleClickHome()
      }).catch(err => { setLoading(false); handleError(err) })
    }
  }

  //初期表示APIコール
  useEffect(() => {
    if (userId && token) {
      let cleanup = false//コンポーネントが破棄された場合に更新処理を止める
      if (role === rolecustomer) {//顧客用
        getUserInfo(userId, userId, token, role).then(res => {
          if (!cleanup) {
            setUserInfo(res)
          }
        }).catch(err => handleError(err))
        //ユーザー情報取得（顧客名、組織名、ユーザー一覧）//メンバー情報一覧取得
        getUserInfoList(userId, userId, token, role).then(u_res => {
          if (!cleanup) {
            setUserInfoList(u_res);
            if (u_res.user) {//custmDepNo初期取得
              let user = u_res.user
              if (typeof user === 'object') {
                let u_adminObj = user.filter(value => value.url)
                getMemberList(userId, userId, token, role).then(m_res => {
                  if (!cleanup) {
                    setMemberList(m_res)
                    if (m_res) {
                      let m_adminObj = m_res.filter(value => value.url)
                      setForm({
                        ...form,
                        custmNo: u_res.custmNo as string,
                        custmDepNo: u_adminObj[0].custmDepNo as string,
                        qPersonCd: m_adminObj[0]['userCd'] ? m_adminObj[0]['userCd'] : '',
                      })
                    }
                  }
                }).catch(err => handleError(err))
              }
            }
          }
        }).catch(err => handleError(err))
        //契約項目取得
        getContractItemList(userId, userId, token, role).then(res => { if (!cleanup) setContractItemList(res) }).catch(err => handleError(err))
        ////カテゴリー取得
        //問合わせ方法
        getCategory('questionway', userId, token, role).then(res => {
          if (!cleanup) {
            setQuestionway(res.filter(value => value.categoryName !== 'Fax'))
          }
        }).catch(err => handleError(err))
        //SuperStreamバージョン
        getCategory('ss_version', userId, token, role).then(res => { if (!cleanup) setSs_version(sortDesc(res)) }).catch(err => handleError(err))
        //サーバー環境（OS）
        getCategory('ss_serverOS', userId, token, role).then(res => { if (!cleanup) { setSs_serverOS(sortDesc(res)) } }).catch(err => handleError(err))
        //サーバー環境（DB）
        getCategory('ss_serverDB', userId, token, role).then(res => { if (!cleanup) { setSs_serverDB(sortDesc(res)) } }).catch(err => handleError(err))
        //サーバー環境（接続）
        getCategory('ss_serverConnect', userId, token, role).then(res => { if (!cleanup) { setSs_serverConnect(sortDesc(res)) } }).catch(err => handleError(err))
        //アプリケーションサーバー
        getCategory('ss_applicationserver', userId, token, role).then(res => { if (!cleanup) { setSs_applicationserver(sortDesc(res)) } }).catch(err => handleError(err))
        //クライアント環境（OS）
        getCategory('ss_clientOS', userId, token, role).then(res => { if (!cleanup) { setSs_clientOS(sortDesc(res)) } }).catch(err => handleError(err))
        //クライアント環境（DB）
        getCategory('ss_clientDB', userId, token, role).then(res => { if (!cleanup) { setSs_clientDB(sortDesc(res)) } }).catch(err => handleError(err))
        return () => { cleanup = true }
      } else if (cisUser(role)) {//社員用
        //顧客情報全取得
        getCustomerList(userId, token, role, '').then(res => {
          if (!cleanup) { setCustomerList(res) }
        }).catch(err => handleError(err))
        //CIS社員情報
        getCisUserList(userId, token, role, '').then(res => {
          if (!cleanup) { setCisUserList(res) }
        }).catch(err => handleError(err))
        ////カテゴリー取得
        //問合わせ方法
        getCategory('questionway', userId, token, role).then(res => {
          if (!cleanup) {
            setQuestionway(res.filter(value => value.categoryCd === '1' || value.categoryCd === '2'))
          }
        }).catch(err => handleError(err))
        //QA対応状況
        getCategory('qastatus', userId, token, role).then(res => {
          if (!cleanup) {
            setQastatus(res.filter(value => value.categoryName === '受付済' || value.categoryName === 'ドラフト'))
          }
        }).catch(err => handleError(err))
        //SuperStreamバージョン
        getCategory('ss_version', userId, token, role).then(res => { if (!cleanup) setSs_version(sortDesc(res)) }).catch(err => handleError(err))
        //サーバー環境（OS）
        getCategory('ss_serverOS', userId, token, role).then(res => { if (!cleanup) { setSs_serverOS(sortDesc(res)) } }).catch(err => handleError(err))
        //サーバー環境（DB）
        getCategory('ss_serverDB', userId, token, role).then(res => { if (!cleanup) { setSs_serverDB(sortDesc(res)) } }).catch(err => handleError(err))
        //サーバー環境（接続）
        getCategory('ss_serverConnect', userId, token, role).then(res => { if (!cleanup) { setSs_serverConnect(sortDesc(res)) } }).catch(err => handleError(err))
        //アプリケーションサーバー
        getCategory('ss_applicationserver', userId, token, role).then(res => { if (!cleanup) { setSs_applicationserver(sortDesc(res)) } }).catch(err => handleError(err))
        //クライアント環境（OS）
        getCategory('ss_clientOS', userId, token, role).then(res => { if (!cleanup) { setSs_clientOS(sortDesc(res)) } }).catch(err => handleError(err))
        //クライアント環境（DB）
        getCategory('ss_clientDB', userId, token, role).then(res => { if (!cleanup) { setSs_clientDB(sortDesc(res)) } }).catch(err => handleError(err))
        return () => { cleanup = true }
      }
    }
  }, [globalState])

  useEffect(() => {//社員用 顧客選択後APIコール
    if (cisUser(role)) {
      let cleanup = false
      setMemberList([])
      setContractItemList([])
      setSelectKeiyaku(undefined)
      if (form.custmDepNo) {
        getMemberList(form.custmDepNo, userId, token, role).then(res => {//顧客メンバー取得
          if (!cleanup) {
            setMemberList(res);
            if (res) {
              let m_adminObj = res.filter(value => value.url)
              setForm({
                ...form,
                qPersonCd: m_adminObj[0]['userCd'] ? m_adminObj[0]['userCd'] : '',
                keiyakuNo: '',
              })
            }
          }
        })
        //契約項目取得
        getContractItemList(form.custmDepNo, userId, token, role).then(res => { if (!cleanup) setContractItemList(res) }).catch(err => handleError(err))
        return () => { cleanup = true }
      }
    }
  }, [form.custmNo, form.custmDepNo])

  //契約項目によってテンプレート文字列を挿入,契約項目変更時にss,Clientを初期化
  useEffect(() => {
    if (selectKeiyaku) {
      if (role === rolecustomer) {
        setForm({
          ...form,
          qaWayClsCd: '0',
          ssVersionClsCd: '',
          serverOsClsCd: '',
          serverDbClsCd: '',
          serverConnectClsCd: '',
          serverAsClsCd: '',
          clientOsClsCd: '',
          clientDbClsCd: '',
        })
      } else {
        setForm({
          ...form,
          qaWayClsCd: '1',
          ssVersionClsCd: '',
          serverOsClsCd: '',
          serverDbClsCd: '',
          serverConnectClsCd: '',
          serverAsClsCd: '',
          clientOsClsCd: '',
          clientDbClsCd: '',
        })
      }
      if (selectKeiyaku.keiyakuClsCd === keiyakuss || selectKeiyaku.keiyakuClsCd === keiyakuss400) {
        if (form.qaContents.length === 0 || form.qaContents.match(/^(\r\n|\n|\r)+$/)) {
          setForm({
            ...form,
            "qaContents": "下記に記載する情報について正確にお知らせいただくことで、より迅速で効果的な問題解決につながります。\r\n対象となる場合に下記項目にお答えください。\r\n\r\n1.[対象となるモジュール]\r\n\r\n2.[いつから現象が発生するか]\r\n\r\n3.[現象の発生に至った手順]\r\n\r\n4.[現象の再現が可能であれば、その再現手順]\r\n\r\n5.[現象発生時のエラーメッセージ、エラー番号]\r\n\r\n6.[パッチ適用状況]\r\n\r\n7.[問題発生の前後、ハードウェア、ソフトウェア等の環境関連の変更を行っていないか]"
          })
        }
      }
    }
  }, [selectKeiyaku])

  //必須項目チェックState更新
  useEffect(() => {
    setReqItem({
      qPersonCd: form.qPersonCd ? false : true,
      qaTitle: form.qaTitle ? false : true,
      qaSeCd: form.qaSeCd ? false : true,
      custmNo: form.custmNo ? false : true,
      keiyakuNo: form.keiyakuNo ? false : true,
    })
  }, [form])


  return (
    <React.Fragment>
      <Typography variant="h6">
        Q&A新規登録
      </Typography>
      <Grid container spacing={2} justify="center" >
        <Grid item xs={12}>
          <Paper>
            {role === rolecustomer &&
              <QARegistFormCR loading={loading} contractItemList={contractItemList} userInfoList={userInfoList} userInfo={userInfo} todayDate={todayDate} form={form} memberList={memberList} selectKeiyaku={selectKeiyaku} ss_version={ss_version} ss_serverOS={ss_serverOS} ss_serverDB={ss_serverDB} ss_serverConnect={ss_serverConnect} ss_applicationserver={ss_applicationserver} ss_clientOS={ss_clientOS} ss_clientDB={ss_clientDB} answerDate={answerDate} reqItem={reqItem} _onValueChanged={_onValueChanged} _onInitialized={_onInitialized} handleChangeForm={handleChangeForm} handleClickMenu={handleClickMenu} handleChangeFile={handleChangeFile} handleRemoveFile={handleRemoveFile} _validator={_validator} onSubmit={onSubmit} handleChangeUserCd={handleChangeUserCd}
              />}
            {cisUser(role) &&
              <QARegistFormEE loading={loading} contractItemList={contractItemList} userInfoList={userInfoList} todayDate={todayDate} form={form} memberList={memberList} selectKeiyaku={selectKeiyaku} questionway={questionway} ss_version={ss_version} ss_serverOS={ss_serverOS} ss_serverDB={ss_serverDB} ss_serverConnect={ss_serverConnect} ss_applicationserver={ss_applicationserver} ss_clientOS={ss_clientOS} ss_clientDB={ss_clientDB} customerList={customerList} cisUserList={cisUserList} answerDate={answerDate} loginUser={loginUser} qastatus={qastatus} reqItem={reqItem} _onValueChanged={_onValueChanged} _onInitialized={_onInitialized} handleChangeForm={handleChangeForm} handleClickMenu={handleClickMenu} handleChangeFile={handleChangeFile} handleRemoveFile={handleRemoveFile} _validator={_validator} onSubmit={onSubmit} handleChangeUserCd={handleChangeUserCd} handleChangeSeCd={handleChangeSeCd} handleChangeCompanyCd={handleChangeCompanyCd} handleSetLoginUserCd={handleSetLoginUserCd}
              />}
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
export default QARegist;